import { storage } from 'firebase/index'
import format from 'date-fns/format'

const imagesRef = storage.ref()

export const uploadImage = async (
  blob: Blob,
  fileType: string,
  folderPath: string, // breads/storeId/breadId など
  handleImageUrl: (value: string) => void
): Promise<void> => {
  const fileName = format(new Date(), "yyyy-MM-dd'T'HH:mm:ss")
  const fileExtension = fileType.split('/')[1]
  const filePath = `${folderPath}/${fileName}.${fileExtension}`
  const uploadRef = imagesRef.child(filePath)
  const uploadTask = uploadRef.put(blob)
  await uploadTask.then()
  const url = await uploadTask.snapshot.ref.getDownloadURL()
  handleImageUrl(url)
  return
}

export const uploadImageInWysiwygEditor = async (blob: Blob, fileType: string, folderPath: string): Promise<string> => {
  const fileName = format(new Date(), "yyyy-MM-dd'T'HH:mm:ss")
  const fileExtension = fileType.split('/')[1]
  const filePath = `${folderPath}/${fileName}.${fileExtension}`
  const uploadRef = imagesRef.child(filePath)
  const uploadTask = uploadRef.put(blob)
  await uploadTask.then()
  return uploadTask.snapshot.ref.getDownloadURL()
}
